import type { ReactNode } from 'react';
import { variant, fields } from 'variant';
import type { VariantOf } from 'variant';

export const SelectOptionAvailability = variant({
  Enabled: {},
  Disabled: fields<{ reason?: ReactNode }>(),
});

type SelectOptionAvailabilityType = VariantOf<typeof SelectOptionAvailability>;

export type SelectOption<T> = {
  title: string;
  description?: ReactNode;
  value: T;
  availability?: SelectOptionAvailabilityType;
} & (T extends string ? { key?: never } : { key: string });

export interface SelectGroup<T> {
  title: string;
  description?: ReactNode;
  items: Array<SelectOption<T>>;
}
